<template>
  <p class="absolute pin-b pin-r mb-16 mr-12" v-if="show">
    <a @click.prevent="sendOsc" href="#" :class="buttonClass" class="bg-no-repeat bg-center rounded py-4 px-4 bg-white hover:bg-red-dark text-grey-darker hover:text-white no-underline uppercase tracking-wide">
      <span :class="{ 'opacity-0' : !buttonText }">Visualize on Model</span>
    </a>
  </p>
</template>
<script>
export default {
  name: 'visualize-control',
  props: ['cue'],

  data () {
    return {
      waitPeriod: 4000, // 4 seconds
      state: 'default' // default, disabled, progress, success
    }
  },

  computed: { 
    wsConnectionState () {
      return this.$store.getters['osc/wsConnection']
    },
    show () {
      if(this.cue) { 
        // We only show the button if the playback is in an idle state, ready to take a command
        if(this.currentD3TrackName === 'idle') {
          return true
        } else {
          // console.log('Vizualize Button - D3 not in an idle state. Hiding')
        }
      }
      return false
    },
    buttonClass () {
      if (this.wsConnectionState != 'open') return 'det__btn--disabled'
      return 'det__btn--' + this.state
    },
    buttonText () {
      return this.state === 'default' || this.state === 'disabled'
    },
    currentD3TrackName () {
      return this.$store.getters['osc/currentD3TrackName']
    },
    queuedOSC () {
      return this.$store.getters['osc/queuedOSC']
    }
  },

  mounted () {
    // this.checkWSState()
  },

  methods: {

    checkWSState () {
      this.$store.dispatch('osc/getOSCStatus')
    },

    setState (state) {
      this.state = state

      if(state === 'success') {
        setTimeout(() => {
          this.setState('default')
        }, this.waitPeriod)
      }
    },

    sendOsc() {
      this.setState('progress')
      this.queueOscRequest()
    },

    queueOscRequest () {
      this.$store.dispatch('osc/sendOscTrigger', this.cue)

      setTimeout(() => {
        this.setState('success')
      }, this.waitPeriod)
    }
  }
}
</script>